import { render, staticRenderFns } from "./BrandPartsType.vue?vue&type=template&id=23a1a398&scoped=true&"
import script from "./BrandPartsType.vue?vue&type=script&lang=js&"
export * from "./BrandPartsType.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsType.vue?vue&type=style&index=0&id=23a1a398&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1a398",
  null
  
)

export default component.exports